<!-- TODO: Beautification -->
<!-- <h4>TODO: Beautiful visualization of data here</h4> -->
<section id="user-profile">
  <div class="row">
    <div class="col-12">
      <div class="card profile-with-cover">
        <div
          class="card-img-top img-fluid bg-cover height-300"
          style="background: url('assets/img/photos/14.jpg') 50%"
        ></div>
        <div class="media profil-cover-details row">
          <div class="col-5">
            <div class="align-self-start halfway-fab pl-3 pt-2">
              <div class="text-left" style="margin-top: -15px">
                <h3 class="card-title white">
                  {{ player?.firstName || 'Player' }} {{ player?.lastName }}
                </h3>
                <h4 class="card-subtitle white">
                  {{ player?.divisionId?.companyId?.name || 'NA' }},
                  {{ player?.divisionId?.name || 'NA' }}
                </h4>
              </div>
            </div>
          </div>
          <div class="col-2">
            <div class="align-self-center halfway-fab text-center">
              <a class="profile-image">
                <img
                  src="assets/img/portrait/avatars/avatar-08.png"
                  class="rounded-circle img-border gradient-summer width-100"
                  alt="Card image"
                  />
                </a>
              </div>
            </div>
            <div class="col-5"></div>
            <div class="profile-cover-buttons">
              <div class="media-body halfway-fab align-self-end">
                <h6 style="margin: 15px" class="card-subtitle white">
                  email: {{ player?.email || 'NA' }}
                </h6>

                <!-- <div class="text-right d-block d-sm-block d-md-block d-lg-none">

              </div> -->
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-4">
            <h6 class="card-subtitle ta-center">
              Current Block: {{ player?.currentBlock?.tileNumber || '0' }}
              @if (player?.currentBlock?.completed) {
                <span
                  ><i
                  style="color: green; padding: 10px"
                  class="fa fa-check"
                  aria-hidden="true"
                  ></i
                ></span>
              }
            </h6>
          </div>
          <div class="col-4">
            <h6 class="card-subtitle ta-center">
              High Score: {{ player?.highestScore || '0' }}
            </h6>
          </div>
          <div class="col-4">
            <h6 class="card-subtitle ta-center">
              Login Count:{{ player?.loginCount || '0' }}
            </h6>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div>
    <div class="row">
      @if (feedbacks && feedbacks.length > 0) {
        <h6
          style="margin: 10px"
          class="card-subtitle col-12"
          >
          feedbacks:
        </h6>
      }

      @for (fb of feedbacks; track fb) {
        <div class="col-12">
          <mat-accordion class="example-headers-align" multi>
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title>
                  {{ fb?.masterGameId?.name }}
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="row" style="margin: 10px">
                @for (feedback of fb.feedback; track feedback) {
                  <div class="col-6">
                    <div class="card p-10">
                      <h6>{{ mapQuestions(feedback?.questionId) }}</h6>
                      <p class="card-subtitle ta-center">
                        {{ feedback?.response }}
                      </p>
                    </div>
                  </div>
                }
              </div>
            </mat-expansion-panel>
          </mat-accordion>
        </div>
      }

      <!-- <div *ngFor="let feedback of feedbacks?.feedback" class="col-6">
      <mat-accordion class="example-headers-align" multi>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              {{ mapQuestions(feedback?.questionId) }}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="row" style="margin:10px">
            <p class="card-subtitle ta-center">{{ feedback?.response }}</p>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
      <div class="card"></div>
    </div> -->
  </div>
</div>
</section>

<!-- {{ player | json }} -->
